const nothingToDo = () => {};
/**
 * Trigger click event on pressing "Enter"
 * @param {EventListener | KeyboardEvent} event
 */
export const clickOnEnter = (event, callback = nothingToDo) => {
  if (event.code === 'Enter' || event.keyCode === 13) {
    event.target.click();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    callback();
  }
};

/**
 * Trigger click event on pressing "Space"
 * @param {EventListener | KeyboardEvent} event
 */
export const clickOnSpace = (event, callback = nothingToDo) => {
  if (event.code === 'Space' || event.keyCode === 32) {
    event.target.click();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    callback();
  }
};

/**
 * Trigger click event on pressing either "Enter" or "Space"
 * @param {EventListener | KeyboardEvent} event
 */
export const clickOnLink = (event, callback = nothingToDo) => {
  if (
    event.code === 'Enter' ||
    event.code === 'Space' ||
    event.keyCode === 13 ||
    event.keyCode === 32
  ) {
    event.target.click();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    callback();
  }
};



// WEBPACK FOOTER //
// ./src/client/utils/genericHelpers.js